import { Link } from "react-router-dom";

const Footer = () => {
    return (
        <footer data-testid="site-footer" className="border-t border-border bg-[#FAF9F6]">
            <div className="mx-auto max-w-7xl px-6 py-20 md:px-10 md:py-24">
                <div className="grid gap-12 md:grid-cols-12">
                    <div className="md:col-span-7">
                        <p className="text-xs uppercase tracking-[0.3em] text-muted-foreground">
                            Ready when you are
                        </p>
                        <h3
                            data-testid="footer-headline"
                            className="mt-5 font-serif text-4xl font-medium leading-[1.05] tracking-tight text-foreground md:text-6xl"
                        >
                            A clean slate
                            <br />
                            for your next chapter.
                        </h3>
                        <p className="mt-6 max-w-xl text-base text-muted-foreground md:text-lg">
                            Start a campaign today. Most kits land in your inbox within 48 hours.
                        </p>
                        <Link
                            to="/apply"
                            data-testid="footer-cta-apply"
                            className="mt-10 inline-flex items-center gap-3 rounded-sm border border-primary bg-primary px-7 py-3.5 text-sm font-medium text-primary-foreground transition-colors hover:bg-foreground"
                        >
                            Start a Campaign
                            <span aria-hidden>→</span>
                        </Link>
                    </div>

                    <div className="grid grid-cols-2 gap-8 md:col-span-5 md:grid-cols-2">
                        <div>
                            <p className="text-xs uppercase tracking-[0.3em] text-muted-foreground">
                                Slate
                            </p>
                            <ul className="mt-5 space-y-3 text-sm">
                                <li><a className="slate-link" href="#how-it-works">How it works</a></li>
                                <li><a className="slate-link" href="#pricing">Pricing</a></li>
                                <li><a className="slate-link" href="#case-study">Case study</a></li>
                                <li><a className="slate-link" href="#faq">FAQ</a></li>
                            </ul>
                        </div>
                        <div>
                            <p className="text-xs uppercase tracking-[0.3em] text-muted-foreground">
                                Contact
                            </p>
                            <ul className="mt-5 space-y-3 text-sm">
                                <li><a className="slate-link" href="mailto:support@get-slate.ai">support@get-slate.ai</a></li>
                                <li><span className="text-muted-foreground">Mon–Fri response within 1 business day</span></li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div className="mt-20 flex flex-col gap-4 border-t border-border pt-8 text-xs text-muted-foreground md:flex-row md:items-center md:justify-between">
                    <p>© {new Date().getFullYear()} Slate. Get-Slate.ai.</p>
                    <p className="font-serif italic">
                        Case studies use anonymized companies and a representative persona. Real outcomes, fictional names.
                    </p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
